class CustomVideoElement extends HTMLElement {
  #updateInterval = null;

  constructor() {
    super();
    this.video = this.querySelector('video');
    this.videoControls = this.querySelector('[data-video-controls]');
    this.videoTimerElement = this.querySelector('[data-video-timer]');
    this.videoPlayButton = this.querySelector('[data-video-play]');
    this.videoSoundButton = this.querySelector('[data-video-sound]');
    this.videoProgress = this.querySelector('[data-video-progress]');
    this.posterImage = this.querySelector('[data-video-poster]');
    this.videoWrapper = this.querySelector('[data-video-wrapper]');
    this.timeFormat = this.dataset.timeFormat;
    this.videoDurationElement = this.querySelector('[data-video-duration]');
    this.videoZoomButton = this.querySelector('[data-video-zoom]');

    this.togglePlay = this.togglePlay.bind(this);
    this.toggleSound = this.toggleSound.bind(this);
    this.onTimeUpdate = this.onTimeUpdate.bind(this);
    this.onVideoEnded = this.onVideoEnded.bind(this);
    this.startTimer = this.startTimer.bind(this);
    this.stopTimer = this.stopTimer.bind(this);

   // console.log('custom-video-element initialized');
  }

  connectedCallback() {
    
    if(!this.posterImage) {

     this.videoWrapper?.removeAttribute('style');    
    }

    if (!this.video) return;

    this.videoPlayButton?.addEventListener('click', (e) => {
      e.preventDefault();
      this.togglePlay();
    });

    this.videoSoundButton?.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleSound();
    });

    this.video.addEventListener('timeupdate', this.onTimeUpdate);
    this.video.addEventListener('ended', this.onVideoEnded);

    this.video.addEventListener('play', () => {
      this.videoPlayButton.textContent = window.theme.strings.video_pause
      this.videoPlayButton.setAttribute('aria-pressed', 'true');
      this.startTimer();
    });

    this.video.addEventListener('pause',  () => {
      this.videoPlayButton.textContent = window.theme.strings.video_play;
      this.videoPlayButton.setAttribute('aria-pressed', 'false');
      this.stopTimer();
    });


    if (this.video.readyState >= 1 /* HAVE_METADATA */) {
    this._setVideoDuration();
    } else {

    this.video.addEventListener('loadedmetadata', this._setVideoDuration.bind(this));
    }

     if (this.videoZoomButton && this.video) {
    this.videoZoomButton.addEventListener('click', () => {
      this.openVideoInModal();
    });
  }

    // Initialize sound button state
    if(this.videoSoundButton) {

          this.videoSoundButton.textContent = this.video.muted ? window.theme.strings.video_sound_off : window.theme.strings.video_sound_on;
    this.videoSoundButton.setAttribute('aria-pressed', String(!this.video.muted));

    }
  

if (this.videoProgress) {
  this._onProgressMouseDown = this.onProgressMouseDown.bind(this);
  this._onProgressTouchStart = this.onProgressTouchStart.bind(this);
  this._onDocumentMouseMove = this.onDocumentMouseMove.bind(this);
  this._onDocumentTouchMove = this.onDocumentTouchMove.bind(this);
  this._onDocumentMouseUp = this.onDocumentMouseUp.bind(this);
  this._onDocumentTouchEnd = this.onDocumentTouchEnd.bind(this);

  const progressContainer = this.videoProgress.parentElement;
  progressContainer.addEventListener('mousedown', this._onProgressMouseDown);
  progressContainer.addEventListener('touchstart', this._onProgressTouchStart, { passive: false });
}

      this._observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.removedNodes.forEach((node) => {
        if (node === this) {  // Observing the removal of the custom element itself
          this.stopTimer();
          if (this.video) {
            try {
              this.video.pause();
            } catch (e) {}
          }
          this._observer.disconnect();
        }
      });
    });
  });

  this._observer.observe(document.body, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.videoPlayButton.removeEventListener('click', this.togglePlay);
    this.videoSoundButton.removeEventListener('click', this.toggleSound);
    this.video.removeEventListener('timeupdate', this.onTimeUpdate);
    this.video.removeEventListener('ended', this.onVideoEnded);
    this.stopTimer();

if (this.videoProgress && this.video) {
  const progressContainer = this.videoProgress.parentElement;
  progressContainer.removeEventListener('mousedown', this._onProgressMouseDown);
  progressContainer.removeEventListener('touchstart', this._onProgressTouchStart);

  document.removeEventListener('mousemove', this._onDocumentMouseMove);
  document.removeEventListener('mouseup', this._onDocumentMouseUp);
  document.removeEventListener('touchmove', this._onDocumentTouchMove);
  document.removeEventListener('touchend', this._onDocumentTouchEnd);
}

     if (this._observer) {
    this._observer.disconnect();
  }

  }

  onProgressTouchStart(event) {
  event.preventDefault();
  this._isDragging = true;
  this.updateVideoTimeFromTouchEvent(event);

  document.addEventListener('touchmove', this._onDocumentTouchMove, { passive: false });
  document.addEventListener('touchend', this._onDocumentTouchEnd);
}

onDocumentTouchMove(event) {
  if (this._isDragging) {
    event.preventDefault();
    this.updateVideoTimeFromTouchEvent(event);
  }
}

onDocumentTouchEnd(event) {
  if (this._isDragging) {
    this._isDragging = false;
    document.removeEventListener('touchmove', this._onDocumentTouchMove);
    document.removeEventListener('touchend', this._onDocumentTouchEnd);
  }
}

  onProgressMouseDown(event) {
  event.preventDefault();
  this._isDragging = true;
  this.updateVideoTimeFromEvent(event);

  document.addEventListener('mousemove', this._onDocumentMouseMove);
  document.addEventListener('mouseup', this._onDocumentMouseUp);
}

onDocumentMouseMove(event) {
  if (this._isDragging) {
    this.updateVideoTimeFromEvent(event);
  }
}

onDocumentMouseUp(event) {
  if (this._isDragging) {
    this.updateVideoTimeFromEvent(event);
    this._isDragging = false;

    document.removeEventListener('mousemove', this._onDocumentMouseMove);
    document.removeEventListener('mouseup', this._onDocumentMouseUp);
  }
}

updateVideoTimeFromEvent(event) {
  const progressBarContainer = this.videoProgress.parentElement;
  const rect = progressBarContainer.getBoundingClientRect();
  const clickX = event.clientX - rect.left;
  const percentage = Math.max(0, Math.min(1, clickX / rect.width));

  if (this.video && !isNaN(this.video.duration)) {
    this.video.currentTime = percentage * this.video.duration;
    if(this.videoTimerElement){
      this.videoTimerElement.textContent = this.formatTime(this.video.currentTime);
    }
    this._updateProgress();
  }
}
updateVideoTimeFromTouchEvent(event) {
  const touch = event.touches[0];
  if (!touch) return;

  const progressBarContainer = this.videoProgress.parentElement;
  const rect = progressBarContainer.getBoundingClientRect();
  const touchX = touch.clientX - rect.left;
  const percentage = Math.max(0, Math.min(1, touchX / rect.width));

  if (this.video && !isNaN(this.video.duration)) {
    this.video.currentTime = percentage * this.video.duration;
    if (this.videoTimerElement) {
      this.videoTimerElement.textContent = this.formatTime(this.video.currentTime);
    }
    this._updateProgress();
  }
}
_updateProgress() {
if (!this.videoProgress || !this.video || isNaN(this.video.duration)) return;

const percent = (this.video.currentTime / this.video.duration) * 100;
this.videoProgress.style.width = `${percent}%`;

}

openVideoInModal() {
  const modal = document.getElementById('video-modal');
  const modalVideo = document.getElementById('modal-video');
  const modalClose = modal.querySelector('.video-modal-close');
  const articleItem = this.video.closest('.article.grid-item');
  let articleTitle = "";

   // Pause all other videos before opening modal
  document.querySelectorAll('video').forEach(v => {
  
      try { v.pause(); } catch (e) {}
  });

  if(articleItem?.querySelector(".article__title")) {
    articleTitle = articleItem.querySelector(".article__title").innerText;
  }


  if(articleTitle) {
    modal.querySelector(".article__title").innerText = articleTitle;
  }
  modalVideo.src = this.video.currentSrc || this.video.querySelector('source')?.src;
  modalVideo.currentTime = this.video.currentTime;
  modalVideo.muted = this.video.muted;
  modalVideo.controls = this.video.controls;
  modalVideo.loop = this.video.loop;
  modalVideo.play();

  modal.style.display = 'flex';

  modalClose.onclick = () => {
    modalVideo.pause();
    modal.style.display = 'none';
    modalVideo.src = '';  // Clear src to stop buffering
  };

  // Close on clicking outside video content
  modal.onclick = (e) => {
    if (e.target === modal) {
      modalVideo.pause();
      modal.style.display = 'none';
      modalVideo.src = '';
    }
  };
}

  _setVideoDuration() {
  const durationFormatted = this.getVideoDuration();

  //console.log("Final", durationFormatted, this.videoDurationElement);

  if (this.videoDurationElement) {
    this.videoDurationElement.textContent = durationFormatted;
  }

  if (this.videoTimerElement && !isNaN(this.video.currentTime)) {
    this.videoTimerElement.textContent = this.formatTime(this.video.currentTime);
  }

     // Initialize progress bar at start
    this._updateProgress();
}

  getVideoDuration() {
  if (!this.video || isNaN(this.video.duration)) return '00:00';

  const totalSeconds = Math.floor(this.video.duration);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const pad = (n) => (n < 10 ? '0' + n : n);

  return `${pad(minutes)}:${pad(seconds)}`;
}

  formatTime(seconds) {
    seconds = Math.floor(seconds || 0);
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);

    const s = seconds % 60;

    const pad = (n) => (n < 10 ? '0' + n : String(n));

    if(this.timeFormat == "MM:SS"){
        return `${pad(m)}:${pad(s)}`;
    }
    return `${pad(h)}:${pad(m)}:${pad(s)}`;
  }

  startTimer() {
    this.stopTimer();
    this.#updateInterval = setInterval(() => {
      if (this.video && !isNaN(this.video.currentTime)) {
        if(this.videoTimerElement){
            this.videoTimerElement.textContent = this.formatTime(this.video.currentTime);
        }
        
         this._updateProgress();
      }
    }, 250);
  }

  stopTimer() {
    if (this.#updateInterval) {
      clearInterval(this.#updateInterval);
      this.#updateInterval = null;
    }
  }

  togglePlay() {
    if (!this.video) return;

    if (this.video.paused || this.video.ended) {
      const playPromise = this.video.play();
      if (playPromise !== undefined) {

        let $this = this;
        playPromise.then(function() {
            $this.videoPlayButton.textContent = window.theme.strings.video_pause
            if($this.posterImage) {
                $this.posterImage.style.display = "none";
            }
            
            $this.videoPlayButton.setAttribute('aria-pressed', 'true');
            $this.startTimer();
          }).catch(function(err) {
            console.warn(`${window.theme.strings.video_error}`, err);
          });
      } else {

        if(this.posterImage) {
            this.posterImage.style.display = "none";
        }
           
          this.videoPlayButton.textContent = window.theme.strings.video_pause
          this.startTimer();

      }

    } else {
          this.video.pause();

        if(this.posterImage) {
            this.posterImage.style.display = "block";
        }
        
        this.videoPlayButton.textContent = window.theme.strings.video_play;
        this.videoPlayButton.setAttribute('aria-pressed', 'false');
        this.stopTimer();
    }
  }

  toggleSound() {
    if (!this.video || !this.videoSoundButton) return;

    this.video.muted = !this.video.muted;
    this.videoSoundButton.textContent = this.video.muted ? window.theme.strings.video_sound_off : window.theme.strings.video_sound_on;
    this.videoSoundButton.setAttribute('aria-pressed', String(!this.video.muted));
  }

  onVideoEnded() {
    this.videoPlayButton.textContent = window.theme.strings.video_play;
    this.videoPlayButton.setAttribute('aria-pressed', 'false');

    if(this.posterImage) {
        this.posterImage.style.display = "block";
    }
    

    this.stopTimer();
    if (!isNaN(this.video.duration)) {
    if(this.videoTimerElement) {
        this.videoTimerElement.textContent = this.formatTime(this.video.duration);
    }
      
    }

     this._updateProgress();

    // Update sound button state
    this.videoSoundButton.textContent = this.video.muted ? window.theme.strings.video_sound_off : window.theme.strings.video_sound_on;
    this.videoSoundButton.setAttribute('aria-pressed', String(!this.video.muted));

  }

  onTimeUpdate() {
    if (this.videoTimerElement && this.video && !isNaN(this.video.currentTime)) {
      this.videoTimerElement.textContent = this.formatTime(this.video.currentTime);
      this._updateProgress();
    }
  }
}

if (!customElements.get('custom-video-element')) {
  customElements.define('custom-video-element', CustomVideoElement);
}